// Glassmorphism — стиль «матового стекла» для тёмного фона.
//
// Использование:
//   <div className={cn(glassSurface, 'rounded-[20px] px-4 py-2')}>
//     <GlassEdge radius={20} />
//     ...контент...
//   </div>
//
// glassSurface вешается на сам элемент (делает его relative, добавляет блюр,
// парящую тень снизу и слабый внутренний glow). GlassEdge — оверлей-кромка
// внутри элемента с НЕРАВНОМЕРНЫМ бликом (ярко на верх-лево/низ-право,
// приглушено на верх-центре и углах верх-право/низ-лево). radius у GlassEdge
// должен совпадать с border-radius родителя.
import { cn } from '@/shared/lib/cn';

export const glassSurface =
  'relative backdrop-blur-md shadow-[0_8px_22px_rgba(0,0,0,0.28),inset_0_-6px_10px_rgba(255,255,255,0.04)]';

// Дефолтный блик кромки — белёсый, рассчитан на ТЁМНЫЙ фон (шапка).
const GLASS_EDGE_DARK_BG =
  'conic-gradient(from 0deg, rgba(255,255,255,0.05), rgba(255,255,255,0.03) 45deg, rgba(255,255,255,0.14) 90deg, rgba(255,255,255,0.38) 135deg, rgba(255,255,255,0.1) 180deg, rgba(255,255,255,0.03) 225deg, rgba(255,255,255,0.14) 270deg, rgba(255,255,255,0.42) 315deg, rgba(255,255,255,0.05) 360deg)';

export function GlassEdge({
  radius = 20,
  width = 1,
  className,
  gradient,
}: {
  radius?: number;
  width?: number;
  className?: string;
  /** Кастомный градиент кромки. По умолчанию — белёсый под тёмный фон. Для
   *  светлого фона передайте тёмный/цветной градиент, иначе кромки не видно. */
  gradient?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn('pointer-events-none absolute inset-0', className)}
      style={{
        borderRadius: radius,
        padding: width,
        background: gradient ?? GLASS_EDGE_DARK_BG,
        mask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        maskComposite: 'exclude',
        WebkitMask:
          'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
        WebkitMaskComposite: 'xor',
      }}
    />
  );
}
